<div class="card1 p-p-4">
    <div class="surface-ground1 px-12 py-12 md:px-12 lg:px-12">
        <div class="registro-panel-content">
            <div class="p-grid">
                <div class="col-12 p-md-12 p-lg-12" *ngIf="cargandoDataInit">
                    <div class="card">
                        <h4>{{mesajeDeCargaInicial}}</h4>
                        <p-progressBar mode="indeterminate"></p-progressBar> 
                    </div>
                </div>

                <div class="surface-card p-4 shadow-2 border-round" *ngIf="!cargandoDataInit">
                    <div class="text-3xl font-medium text-900 mb-3">{{ currentUser.initials }}</div>
                    <form
                        #subjectEditorForm="ngForm"
                        (ngSubmit)="mejorarPlan()"
                        [ngClass]="{ disabledForm: false }"
                        autocomplete="false">

                        <p-messages [(value)]="msgs"></p-messages>
                        <div class="p-fluid p-formgrid grid">
                            <div class="p-field col-12" *ngIf="planesUsuario && planesUsuario.length > 0">
                                <div class="p-field col-12">
                                    <div class="card shadow-1 p-4 border-round-left border-round-border-round-right">
                                        <div class="text-900 font-bold text-blue-900 text-xl">Tus planes</div>
                                        <p *ngIf="planesUsuario && planesUsuario.length > 0" class="text-700">¡Genial! Tu FacturaFácilEcuador ahora mejor que nunca.</p>
                                        <div *ngFor="let item of planesUsuario" class="flex align-items-center justify-content-between mb-3">
                                            <span class="text-700 text-lg"><i class="pi pi-star-fill text-yellow-500"></i> {{item.name}}</span>
                                            <!--<span class="text-900 font-bold">$ {{item.precio}}</span>-->
                                        </div>
                                    </div>
                                </div>
                                <div class="field col-12">

                                    <button pButton type="button" 
                                            class="p-button-info"
                                            (click)="abrirTerminosCondiciones()" icon="pi pi-info-circle" label="Leer términos y condiciones"></button>
                                </div>
                                <div class="field col-12">
                                    <p-toggleButton #aceptaTerminosCondicionesfrm="ngModel" inputId="aceptaTerminosCondicionesfrm" name="aceptaTerminosCondicionesfrm"
                                                    [(ngModel)]="newUser.planAceptaTerminosCondiciones" 
                                                    onIcon="pi pi-check" offIcon="pi pi-times" 
                                                    onLabel="{{appConfig.ux.actions.acceptTerm}}"
                                                    offLabel="{{appConfig.ux.actions.acceptTerm}}"
                                                    [class]="newUser.planAceptaTerminosCondiciones ? 'p-togglebutton-accept' : ''">
                                    </p-toggleButton>
                                </div>
                            </div>
                            <div class="p-field col-12">
                                <div class="card shadow-1 p-2">
                                    <p-carousel [value]="planesFactura" 
                                                [numVisible]="3" [numScroll]="3" [circular]="true" [responsiveOptions]="responsiveOptions">
                                        <ng-template pTemplate="header">
                                            <div class="p-2 font-medium">Selecciona el plan de facturación electrónica:</div>
                                        </ng-template>
                                        <ng-template let-item pTemplate="item">
                                            <div class="p-3 h-full">
                                                <div class="product-item-content">
                                                    <div class="mb-3 text-2xl text-yellow-800">{{item.tipo}}</div>
                                                    <div class="px-2">
                                                        <h4 class="mb3">{{item.name}}</h4>
                                                        <p class="mb-3 text-700 text-xs line-height-3">{{item.description}}</p>
                                                        <p *ngIf="item.visiblePrecio" class="text-4xl">${{ item.precio ? item.precio.toFixed(2) : '0.00'}}</p>
                                                    </div>
                                                    <button
                                                        pButton
                                                        type="button"
                                                        label="{{ 'Agregar' }}" tooltipPosition="bottom"
                                                        icon="pi pi-shopping-cart" class="bg-yellow-400"
                                                        style="display: inline-block"
                                                        (click)="agregarPlanSeleccionado(event, item)"></button>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </p-carousel>
                                </div>
                            </div>
                            <div class="p-field col-12">
                                <div class="card shadow-1 p-2">
                                    <p-carousel [value]="planesFirma" 
                                                [numVisible]="3" [numScroll]="3" [circular]="true" [responsiveOptions]="responsiveOptions">
                                        <ng-template pTemplate="header">
                                            <div class="p-2 font-medium">¿Necesitas Firma electrónica? Seleccione la duración:</div>
                                        </ng-template>
                                        <ng-template let-item pTemplate="item">
                                            <div class="p-3 h-full">
                                                <div class="product-item-content">
                                                    <div class="mb-3 text-2xl text-yellow-800">{{item.tipo}}</div>
                                                    <div class="px-2">
                                                        <h4 class="mb3">{{item.name}}</h4>
                                                        <p class="mb-3 text-700 text-xs line-height-3">{{item.description}}</p>
                                                        <p *ngIf="item.visiblePrecio" class="text-4xl">${{ item.precio ? item.precio.toFixed(2) : '0.00'}}</p>
                                                    </div>
                                                    <button
                                                        pButton
                                                        type="button"
                                                        label="{{ 'Agregar' }}" tooltipPosition="bottom"
                                                        icon="pi pi-shopping-cart" class="bg-yellow-400"
                                                        style="display: inline-block"
                                                        (click)="agregarPlanSeleccionado(event, item)"></button>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </p-carousel>
                                </div>
                            </div>
                        </div>
                        <p-toast position="bottom-center" key="bc"></p-toast>
                        <p-footer>
                            <div class="flex align-items-center justify-content-between">
                                <button
                                    pButton
                                    type="button"
                                    label="{{ appConfig.ux.actions.back }}"
                                    icon="pi pi-arrow-left"
                                    class="p-button-secondary"
                                    (click)="irARegistrarCancel(event)"></button>
                                <button
                                    pButton
                                    type="submit"
                                    label="Mejorar mi plan ahora"
                                    icon="pi pi-check" class="p-ml-lg-1"
                                    [disabled]="(!subjectEditorForm.valid || !newUser.planAceptaTerminosCondiciones
                                    || !(planesUsuario && planesUsuario.length > 0))">
                                </button>
                            </div>
                        </p-footer>                                
                        <p-messages [(value)]="msgs"></p-messages>
                    </form>
                </div>
            </div>

        </div>
    </div>
</div>

<p-dialog header="Términos y condiciones" [(visible)]="mostrarTerminosCondiciones"
          [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}">
    <iframe name="terminoscondiciones" 
            style="width: 100%; height: 500px"
            class="hidden-frame" src="https://www.facturafacilecuador.com/terminos.html"></iframe>
</p-dialog>

